import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

//  路由跳转的时候同一个路由多次添加是不被允许的
//  重写路由的push方法
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/',
            component: () => import('../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/homeInfo',
                    component: () => import('../components/page/home/HomeInfo.vue'),
                    meta: { title: '首页', index: ['homeInfo'] }
                },
                {   
                    path: '/acSourceVoucher', 
                    component: () => import('../components/page/archives/AC-SourceVoucher.vue'),
                    meta: { title: '原始凭证', index: ['acSourceVoucher'] }
                },
                {
                    path: '/acAccountingVoucher',
                    component: () => import('../components/page/archives/AC-AccountingVoucher.vue'),
                    meta: { title: '记账凭证', index: ['acAccountingVoucher'] }
                },
                {
                    path: '/relationAccountingVoucher',
                    component: () => import('../components/page/archives/Relation-ArchivesVoucher.vue'),
                    meta: { title: '关联记账凭证', index: ['relationAccountingVoucher'] }
                },
                {
                    path: 'acArchivesView',
                    component: () => import('../components/page/archives/AC-ArchivesView.vue'),
                    meta: { title: '文件查看', index: ['acArchivesView'] }
                },
                {
                    path: 'avVoucherValidation',
                    component: () => import('../components/page/archives/AV-VoucherValidation.vue'),
                    meta: { title: '凭证验证', index: ['avVoucherValidation'] }
                },
                {
                    path: '/aaArchivesGroup', // 档案分组
                    component: () => import('../components/page/archives/AA-ArchivesGroup.vue'),
                    meta: { title: '档案分组', index: ['aaArchivesGroup'] }
                },
                {
                    path: '/aaArchivesVolume', // 档案成册
                    component: () => import('../components/page/archives/AA-ArchivesVolume.vue'),
                    meta: { title: '档案成册', index: ['aaArchivesVolume'] }
                },
                {
                    name: 'archivesRetrieval',
                    path: '/archivesRetrieval', //  档案检索
                    component: () => import('../components/page/archives/AR-ArchivesRetrieval.vue'),
                    meta: { title: '档案检索', index: ['archivesRetrieval'] }
                },
                {
                    name: 'archivesRetrievalFuzzySearch',
                    path: '/archivesRetrievalFuzzySearch',   //  档案检索-模糊查找
                    component: () => import('../components/page/archives/AR-ArchivesFuzzySearch.vue'),
                    meta: { title: '档案检索 - 模糊查找'},
                    hidden: true    //  是否显示在菜单
                },
                {
                    path: '/roleManage',
                    component: () => import('../components/page/sys/role-m.vue'),
                    meta: { title: '角色管理', index: ['roleManage'] }
                },
                {
                    path: '/invCompany',
                    component: () => import('../components/page/sys/inv-company.vue'),
                    meta: { title: '开票公司', index: ['invCompany'] }
                },
                {
                    path: '/userManage',
                    component: () => import('../components/page/sys/user-m.vue'),
                    meta: { title: '用户管理', index: ['userManage'] }
                },
                {
                    path: '/emailManage',
                    component: () => import('../components/page/sys/email-m.vue'),
                    meta: {title: '邮箱服务器管理', index: ['emailManage']}
                },
                {
                    path: '/scheduleTaskInstanceManage',
                    component: () => import('../components/page/sys/scheduleTaskInstance-m.vue'),
                    meta: {title: '定时任务实例管理', index: ['scheduleTaskInstanceManage']}
                },
                {
                    path: '/groupCompany',
                    component: () => import('../components/page/super/group-company.vue'),
                    meta: { title: '集团管理', index: ['groupCompany'] }
                },
                {
                    path: '/groupUser',
                    component: () => import('../components/page/super/group-user.vue'),
                    meta: { title: '集团用户', index: ['groupUser'] }
                },
                {
                    path: '/globalUserRelation',
                    component: () => import('../components/page/super/global-user-relation.vue'),
                    meta: { title: '用户维护', index: ['globalUserRelation']}
                }
            ]
        },
        {
            path: '/login',
            component: () => import('../components/page/Login.vue'),
            meta: { title: '登录' }
        },
		{
		    path: '/portalLogin',
		    component: () => import('../components/page/PortalLogin.vue'),
		    meta: { title: '登录' }
		},
        {
            path: '/login/:token',
            component: () => import('../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '/downloadAttachment',
            component: () => import('../components/page/DownloadAttachment.vue'),
            meta: { title: '附件下载' }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});
